module.exports = __webpack_public_path__ + "f9277aa42d2fb118a8e163c242665fe6.svg";